import cn from 'classnames';
import { useRouter } from 'next/router';

import Cover from 'components/common/Cover';

import SeatsLeft from 'components/widget/SeatsLeft';
import BroadcastStatusMark from 'components/widget/BroadcastStatus';

import { useBroadcastsStatus } from 'hooks/utils/useBroadcastsStatus';

import { BroadcastType } from 'graphql/types';

import { AnalyticsEvent, trackAnalyticsData } from 'utils/analytics';
import { getEventFormattedDate } from 'utils/dates';

import css from './EventPreview.module.scss';

interface IProps {
  heightSize: 'small' | 'normal' | 'large';
  link: string;
  dateStart?: string;
  dateEnd?: string;
  enrollFinishDate?: string;
  city?: string;
  title: string;
  background: string;
  seats?: number;
  capacity?: number;
  isOffline?: boolean;
  isRegistrationOff?: boolean;
  broadcasts: BroadcastType[];
}

export default function EventPreview(props: IProps) {
  const {
    heightSize = 'normal',
    link,
    dateStart,
    dateEnd,
    enrollFinishDate,
    city,
    title,
    background,
    seats,
    capacity,
    isOffline,
    isRegistrationOff,
    broadcasts,
  } = props;
  const { pathname } = useRouter();

  const broadcastsStatus = useBroadcastsStatus(broadcasts || []);

  const classes = cn(css.cover, heightSize && css[heightSize]);

  const handleEventPreviewClick = () => {
    const eventName =
      pathname === '/'
        ? AnalyticsEvent.MAIN_EVENTS_PREVIEW_CLICK
        : AnalyticsEvent.EVENTS_PREVIEW_CLICK;

    trackAnalyticsData(eventName, {
      slug: link.replace('/events/', ''),
      dateStart,
      dateEnd,
      isOffline,
    });
  };

  return (
    <Cover
      size="small"
      background={background}
      imgProxyProps={{
        sourceWidth: 800,
        sourceHeight: 450,
        resizingType: 'fill',
        gravityType: 'ce',
      }}
      className={classes}
      link={link}
      onClick={handleEventPreviewClick}
    >
      <Cover.Top
        widgets={{
          left: !isOffline ? (
            <BroadcastStatusMark settings={broadcastsStatus} withTime />
          ) : !isRegistrationOff ? (
            <SeatsLeft
              enrollFinishDate={enrollFinishDate}
              number={seats}
              capacity={capacity}
            />
          ) : null,
        }}
      />
      <Cover.Content>
        <Cover.Title>
          <div className={css.date}>
            {dateStart && dateEnd && getEventFormattedDate(dateStart, dateEnd)}
            {city && <span className={css.dateSeparator}>•</span>}
            {city}
          </div>
          {title}
        </Cover.Title>
      </Cover.Content>
    </Cover>
  );
}
